import { Pie } from 'react-chartjs-2'
import { useIntl } from 'react-intl'
import { ChartConfiguration } from 'chart.js'

import { CHART_COLORS, CHART_FONT } from 'Constants/charts'

import { DeviceCountCardChartProps } from './DeviceCountCardChart.types'
import { deviceCountCardChartLegendPlugin } from './DeviceCountCardChart.util'

export const DeviceCountCardChart = (props: DeviceCountCardChartProps) => {
  const { data, labels } = props

  const intl = useIntl()

  const chartConfig: ChartConfiguration<'pie'> = {
    data: {
      datasets: [
        {
          backgroundColor: CHART_COLORS,
          data,
          label: intl.formatMessage({ id: 'Total' }),
        },
      ],
      labels,
    },
    options: {
      maintainAspectRatio: false,
      plugins: {
        htmlLegend: {
          containerID: 'deviceCountCardLegend',
        },
        legend: {
          display: false,
        },
        tooltip: {
          bodyFont: CHART_FONT,
          titleFont: CHART_FONT,
        },
      },
      responsive: true,
    },
    plugins: [deviceCountCardChartLegendPlugin],
    type: 'pie',
  }

  return (
    <div className="d-flex flex-column flex-lg-row">
      <div className="DashboardDeviceCountCard-chart">
        <Pie {...chartConfig} />
      </div>

      <div
        className="DashboardDeviceCountCard-legend"
        id="deviceCountCardLegend"
      />
    </div>
  )
}
